import { ZfIcon, ZfIconButton } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { WRITABLE_CATEGORIES_CLM } from '../../../app/config/constants';
import { useYwuApp } from '../../../app/contexts/ywu-app-context';
import { WealthOverviewEntrySource } from '../../../app/enums';
import { useWealthPlanningNavigate } from '../../../app/hooks/useWealthPlanningNavigate';
import { wnSendNavigate } from '../../../app/utils/wn-event-utils';
import type { LiquidityOverviewTableRow } from '../../interfaces';

export const LiquidityOverviewActionsCell: FunctionComponent<ICellRendererParams<LiquidityOverviewTableRow>> = ({ data }) => {
    const { isWealthNavigatorMFE } = useYwuApp();
    const { clientUuid, isOpenedInClientContext } = useWealthPlanningNavigate();

    const icon = useMemo(() => {
        if (!data) return 'visibility';
        if (isWealthNavigatorMFE && isOpenedInClientContext && clientUuid) return 'arrow_forward';

        const isEditableClm =
            data.source === 'EXTERNAL' &&
            data.qualifiedId?.source === WealthOverviewEntrySource.PCM_CORE &&
            data.categoryId != null &&
            WRITABLE_CATEGORIES_CLM.includes(data.categoryId);

        return isEditableClm ? 'edit' : 'visibility';
    }, [clientUuid, data, isOpenedInClientContext, isWealthNavigatorMFE]);

    const onClick = () => {
        if (!data) return;

        if (isWealthNavigatorMFE && isOpenedInClientContext && clientUuid) {
            wnSendNavigate(`client-data/${clientUuid}/INTL/client-book`);

            return;
        }

        const { onLiquidityRowAction, ...position } = data;
        onLiquidityRowAction(position);
    };

    if (!data) return null;

    return (
        <div>
            <ZfIconButton hierarchy="tertiary" style={{ display: 'flex', alignItems: 'center' }} onClick={onClick}>
                <ZfIcon name={icon} size="small" />
            </ZfIconButton>
        </div>
    );
};
